export interface SaveCostCentreApiErrors {
  account_not_available: boolean;
  cost_centre_name_not_available: boolean;
  account_not_visible: boolean;
}

export const DEFAULT_SAVE_COST_CENTRE_API_ERRORS = {
  account_not_available: false,
  cost_centre_name_not_available: false,
  account_not_visible: false,
};

export const SAVE_COST_CENTRE_ERROR_MESSAGES = {
  account_not_available: 'La cuenta seleccionada no está disponible',
  cost_centre_name_not_available: 'Ya existe un centro de costos con ese nombre',
  account_not_visible: 'El centro de costos seleccionado no es válido',
  default: 'Hubo un error al intentar guardar el centro de costos',
};
